import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      borderRadius: theme.shape.borderRadius,
      height: 64,
      backgroundColor: '#3F4C66',
      padding: theme.spacing(1.5, 2),

      '&:hover': {
        backgroundColor: COLORS.neutral.mediumGray,
      },

      '&$expanded': {
        backgroundColor: theme.palette.darkSelected,
      },
    },
    names: {
      width: '100%',
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'stretch',
      overflow: 'hidden',
    },
    productWorkspace: {
      fontSize: theme.typography.pxToRem(11),
      lineHeight: theme.typography.pxToRem(13),
      fontWeight: theme.typography.fontWeightMedium,
      color: COLORS.neutral.silver,
      width: 'max-content',
    },
    workspaceName: {
      textAlign: 'start',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      fontSize: theme.typography.pxToRem(13),
      lineHeight: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightMedium,
      marginTop: theme.spacing(0.5),
      color: theme.palette.common.white,
    },
    workspaceGroup: {
      display: 'flex',
      marginTop: theme.spacing(0.5),
    },
    firstLetter: {
      textTransform: 'capitalize',
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(10),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '4px',
      color: COLORS.gray.black,
      backgroundColor: COLORS.primary.light,
      padding: theme.spacing(0.75),
      fontWeight: theme.typography.fontWeightMedium,
      width: 24,
      height: 24,
      marginRight: theme.spacing(1),
    },
    iconExpand: {
      color: theme.palette.text.secondary,
      marginRight: theme.spacing(-0.5),
      fontSize: theme.typography.pxToRem(20),
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
      '&$expanded': {
        transform: 'rotate(180deg)',
      },
    },
    expanded: {},
  }),
  { name: 'WorkspaceButton' }
);
